import { /* Badge, */ Descriptions, Button, Form, Input, Steps } from "antd";
import React, { /* useCallback,  */ useEffect, useState, useRef } from "react";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
// import StyledModal from "antComponents/Modal";
import getUserInfo from "controllers/getUserInfo";
import { Spin, Avatar, Switch, Modal } from "antd";
import { UserOutlined } from "@ant-design/icons";
import StyledModal from "antComponents/Modal";
import GoogleOTP from "./GoogleOTP";
import axios from "axios";
import FormItemInput from "antd/lib/form/FormItemInput";
import PictureUpload from "./ PictureUpload";
import newDateTime from "controllers/newDateTime";
import { auto } from "async";

const UserInfo = () => {
  const backend = process.env.REACT_APP_BACKEND;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.mainReducer.authState);
  const [otpModal, setOtpModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [otpCancelModal, setOtpCancelModal] = useState(false);
  const [otpCancelStep, setOtpCancelStep] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const userInfo = useSelector((state) => state.mainReducer.userInfo);
  const otpRef = useRef(null);
  const passwordRef = useRef(null);
  const { Step } = Steps;
  const [spinState, setSpinState] = useState(true);
  const [count, setCount] = useState(-1);
  const [authCodeCheck, setAuthCodeCheck] = useState([true, ""]);
  const [passwordCheck, setPasswordCheck] = useState([true, ""]);
  const [otpCodeCheck, setOtpCodeCheck] = useState([true,""])


  const otpCheckHandler = (checked) => {
    // console.log(checked);
    if (checked === true) {
      setOtpModal(true);
    } else if (checked === false) {
      setOtpCancelModal(true);
      // Modal.confirm({
      //   title: "MFA 비활성화",
      //   content: "MFA를 제거하고 비활성화 합니다. 진행하시겠습니까?",
      //   onOk: () => {
      //     axios
      //       .post(`${backend}/userInfo/otpChange`, { google_otp_use_yn: "N" })
      //       .then((data) => {
      //         console.log(data.data.data);
      //         dispatch(authAction(true, data.data.data));
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //         if (err.response.status === 401) {
      //           dispatch(authAction(false, null));
      //         }
      //       });
      //   },
      //   okText: "확인",
      //   cancelText: "취소",
      // });
    }
  };

  const otpModalCancel = () => {
    if (currentStep === 0) {
      setOtpModal(false);
      setCurrentStep(0);
    } else {
      axios
        .post(`${backend}/userInfo/otpChange`, { google_otp_use_yn: "N" })
        .then((data) => {
          // console.log(data);
          setOtpModal(false);
          setCurrentStep(0);
          setCount(-1);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const otpModalOk = async (e) => {
    if (currentStep < 2) {
      await setCurrentStep(currentStep + 1);
    } else if (currentStep === 2) {
      const { emailCode, otpCode } = otpRef.current.getFieldsValue();
      otpRef.current
        .validateFields()
        .then((data) => {
          // console.log(data);
          axios
            .post(`${backend}/userInfo/otpChangeRequest`, {
              emailCode,
              otpCode,
            })
            .then((data) => {
              if (data.status === 203) {
                if(data.data.method === "email") {
                  otpRef.current.setFields([
                    {
                      name:["emailCode"],
                      errors:[data.data.message],
                    }
                  ])
                } else if (data.data.method === "otp") {
                  otpRef.current.setFields([{
                    name: "otpCode",
                    errors:[data.data.message]
                  }])
                }
                } else {
                  setCount(-1);
                dispatch(authAction(true, data.data.data));
                setCurrentStep(currentStep + 1);
                }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.status === 401) {
                dispatch(authAction(false, null));
              }
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setCurrentStep(0);
      setOtpModal(false);
    }
  };

  function changePassword() {
    // console.log(passwordRef);
    if (userInfo && userInfo.google_otp_use_yn === "N") {
      Modal.warning({
        title: "확인",
        okText: "확인",
        content:
          "비밀번호를 설정하기 위하여는 MFA 를 사용하도록 설정되어있어야 합니다. 먼저 MFA 사용여부를 활성화 시키세요.",
      });
    } else {
      setPasswordModal(true);
    }
  }

  async function changePasswordOK() {
    passwordRef.current
      .validateFields()
      .then((data) => {
        // console.log(data);
        const { emailCode, otpCode, newPassword, newPasswordCheck } = data;
        axios
          .post(`${backend}/userInfo/passwordChange`, { ...data })
          .then((data) => {
            // console.log(data.data)
            if (data.status === 203) {
              if(data.data.method === "email") {
                setAuthCodeCheck([false,data.data.message])
              } else if(data.data.method === "otp") {
                setOtpCodeCheck([false, data.data.message])
              }
            } else {
            // console.log(data);
            setPasswordModal(false);
            setCount(-1);
            passwordRef.current.resetFields();
            Modal.info({
              title: "비밀번호 변경 완료",
              okText:"확인",
              content: "비밀번호가 정상적으로 변경되었습니다.",
              afterClose: () => {
                dispatch(authAction(true, data.data.data));
              },
            });
          }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.status === 401) {
              Modal.error({
                title: "인증 에러",
                content:
                  "세션 인증기간이 만료되었습니다. 다시 로그인 해 주세요.",
                afterClose: () => {
                  dispatch(authAction(false, null));
                },
              });
            }
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const sendEmail = async () => {
    setSpinning(true);
    setAuthCodeCheck([true,""])
    if(otpRef.current !== null) {
    otpRef.current.resetFields(["emailCode"]); // 코드 전송 버튼을 누르자마자
    }
    if(passwordRef.current !==null) {
      passwordRef.current.resetFields(["emailCode"])
    }
    await axios
      .post(`${backend}/authentication/email`, { email: userInfo.email })
      .then((data) => {
        setSpinning(false);
        setCount(data.data.count - 2);
        return Modal.success({ content: data.data.message, okText: "확인" });
      })
      .catch((err) => {
        setSpinning(false);
        return StyledModal.error("코드전송 에러", err.response.data.message);
      });
  };

  const passwordCheckValidator = (_, value) => {
    if (!value) {
      return Promise.resolve();
    }
    if (passwordRef.current.getFieldValue("newPassword") === value) {
      return Promise.resolve();
    } else {
      return Promise.reject(new Error("비밀번호 입력값이 동일하지 않습니다."));
    }
  };

  const otpCancelNext = () => {
    if (otpCancelStep === 0) {
      otpRef.current
        .validateFields()
        .then((data) => {
          // console.log(data);
          axios
            .post(`${backend}/userInfo/otpCancel`, { isDelete: false, ...data })
            .then((data) => {
              if (data.status === 203 && data.data.method === "authCode") {
                setAuthCodeCheck([false, data.data.message]);
              } else if (
                data.status === 203 &&
                data.data.method === "passWord"
              ) {
                setPasswordCheck([false, data.data.message]);
              } else if (data.status === 200) {
                // console.log(data);
                setCount(-1);
                setOtpCancelStep(otpCancelStep + 1);
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.status === 401) {
                Modal.error({
                  title: "인증 에러",
                  content:
                    "세션 인증기간이 만료되었습니다. 다시 로그인 해 주세요.",
                  afterClose: () => {
                    dispatch(authAction(false, null));
                  },
                });
              }
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (otpCancelStep === 1) {
      axios
        .post(`${backend}/userInfo/otpCancel`, { isDelete: true })
        .then((data) => {
          dispatch(authAction(true, data.data.data));
          setOtpCancelStep(otpCancelStep + 1);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            Modal.error({
              title: "인증 에러",
              content: "세션 인증기간이 만료되었습니다. 다시 로그인 해 주세요.",
              afterClose: () => {
                dispatch(authAction(false, null));
              },
            });
          }
        });
    } else {
      setOtpCancelModal(false);
      setOtpCancelStep(0);
    }
  };

  const otpCancelCancel = () => {
    if (otpCancelStep === 0) {
      setOtpCancelModal(false);
      setOtpCancelStep(0);
      setCount(-1);
      setAuthCodeCheck([true,""])
      setPasswordCheck([true,''])
      otpRef.current.resetFields();
    } else {
      setOtpCancelModal(false);
      setOtpCancelStep(0);
      setCount(-1);
    }
  };
  // console.log(otpRef.current && otpRef.current.getFieldsValue());

  const authCodeValidator = (_, value) => {
    const regExpCode = new RegExp(/^[0-9]{6}$/);
    // console.log(authCodeCheck)
    if (!value && authCodeCheck[0]) {
      return Promise.resolve();
    }
    if (!authCodeCheck[0]) {
      return Promise.reject(new Error(authCodeCheck[1]));
    }
    if (regExpCode.test(value) === false) {
      return Promise.reject(new Error("인증코드 형식이 맞지 않습니다."));
    }
    return Promise.resolve();
  };

  const otpCodeValidator = (_, value) => {
    const regExpCode = new RegExp(/^[0-9]{6}$/);
    // console.log(otpCodeCheck)
    if (!value && otpCodeCheck[0]) {
      return Promise.resolve();
    }
    if (!otpCodeCheck[0]) {
      return Promise.reject(new Error(otpCodeCheck[1]));
    }
    if (regExpCode.test(value) === false) {
      return Promise.reject(new Error("인증코드 형식이 맞지 않습니다."));
    }
    return Promise.resolve();
  };

  const passwordValidator = (_, value) => {
    if (!value && passwordCheck[0]) {
      return Promise.resolve();
    }
    if (!passwordCheck[0]) {
      return Promise.reject(new Error(passwordCheck[1]));
    }
    return Promise.resolve();
  };

  const viewPicture = (_) => {
    Modal.info({
      content: (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
          <img src={`https://englemining-admin.s3.ap-northeast-2.amazonaws.com/${userInfo.thumbnail}`} style={{width:"100%"}}/>
        </div>
      ),
      icon: null,
      maskClosable: true,
      okButtonProps: {style: {display: 'none'}},
      bodyStyle: {padding:0},
      style: {padding: 0},
      className: "picture_modal",
    })
  }

  useEffect(() => {
    getUserInfo().then((data) => {
      dispatch(authAction(data.state, data.userInfo));
    });
    setSpinState(false);
  }, []);

  useEffect(() => {
    if (count > 0) {
      const codeTime = setInterval(() => {
        setCount(count - 1);
      }, 1000);
      return () => {
        clearInterval(codeTime);
      };
    } else if (count === 0) {
      setCount(-1);
      setAuthCodeCheck([true, ""]);
    }
  });

  useEffect(() => {
    if (authCodeCheck[0] === false) {
      if(otpRef.current) {
      otpRef.current.validateFields();
      }
      if(passwordRef.current){
        passwordRef.current.validateFields()
      }
    }
    if (passwordCheck[0] === false) {
      if(otpRef.current) {
        otpRef.current.validateFields();
        }
    }
    if(otpCodeCheck[0] === false) {
        if(passwordRef.current){
          passwordRef.current.validateFields()
        }
    }
  }, [authCodeCheck, passwordCheck, otpCodeCheck]);


  return (
    <div style={{ width: "100%", minWidth: "1000px" }}>
      <Modal
        title="MFA 활성화"
        open={otpModal}
        width="50%"
        maskClosable={false}
        onCancel={otpModalCancel}
        footer={
          <>
            <Button type="primary" onClick={otpModalOk}>
              {currentStep === 2 ? "완료" : currentStep === 3 ? "확인" : "다음"}
            </Button>
            {currentStep === 3 ? null : (
              <Button onClick={otpModalCancel}>
                취소
              </Button>
            )}
          </>
        }
        // okText= {currentStep === 2 ? "완료" : currentStep === 3 ? "확인" : "다음"}
        // cancelText={"취소"}
        // onOk={(e) => otpModalOk(e)}
        // onCancel={currentStep === 3 ? null : otpModalCancel}
      >
        <GoogleOTP currentStep={currentStep} ref={otpRef} />
      </Modal>

      <Modal
        title="MFA 비활성화"
        open={otpCancelModal}
        width="50%"
        maskClosable={false}
        onCancel={otpCancelCancel}
        footer={
          <>
            {otpCancelStep < 2 ? (
              <Button onClick={otpCancelNext}>다음</Button>
            ) : (
              <Button type="primary" onClick={otpCancelNext}>
                완료
              </Button>
            )}
            {otpCancelStep < 2 ? (
              <Button type="primary" onClick={otpCancelCancel}>
                취소
              </Button>
            ) : null}
          </>
        }
      >
        <Steps
          size="small"
          current={otpCancelStep}
          style={{ marginBottom: "20px" }}
        >
          <Step title="인증" />
          <Step title="확인" />
          <Step title="완료" />
        </Steps>
        {otpCancelStep === 0 ? (
          <div style={{ height: "150px" }}>
            <Form ref={otpRef}>
              <Spin spinning={spinning}>
                <Form.Item
                  name="emailCode"
                  validateTrigger={["onChange", "onBlur"]}
                  onChange={() => {
                    setAuthCodeCheck([true, ""]);
                  }}
                  rules={[
                    {
                      required: true,
                      message: "이메일 인증코드를 입력하세요.",
                    },
                    {
                      validator: authCodeValidator,
                      validateTrigger: "onBlur",
                    },
                  ]}
                >
                  <Input
                    placeholder="이메일 인증 코드"
                    suffix={
                      count > 0 ? (
                        <div style={{ color: "red" }}>{count}</div>
                      ) : (
                        <span style={{ cursor: "pointer" }} onClick={sendEmail}>
                          코드 전송
                        </span>
                      )
                    }
                  ></Input>
                </Form.Item>
              </Spin>
              <Form.Item
                name="password"
                onChange={() => {
                  setPasswordCheck([true, ""]);
                }}
                validateTrigger={["onBlur", "onChange"]}
                rules={[
                  {
                    required: true,
                    message: "비밀번호를 입력하세요.",
                  },
                  {
                    validator: passwordValidator,
                    validateTrigger: "onBlur",
                  },
                ]}
              >
                <Input.Password placeholder="비밀번호"></Input.Password>
              </Form.Item>
            </Form>
            <div>
              MFA 사용을 비활성화 하기 위해서는 위에 이메일 인증코드와
              비밀번호를 입력 후 아래의 ‘다음' 버튼을 클릭하세요.
            </div>
          </div>
        ) : otpCancelStep === 1 ? (
          <div style={{ height: "150px" }}>
            정말 MFA 를 사용 하지 않도록 하시겠습니까 ?
          </div>
        ) : (
          <div style={{ height: "150px" }}>
            MFA 를 사용하지 않도록 비활성화 되었습니다.
          </div>
        )}
      </Modal>

      <Modal
        title="비밀번호 변경"
        open={passwordModal}
        okText="확인"
        cancelText="취소"
        maskClosable={false}
        onOk={changePasswordOK}
        onCancel={() => {
          setPasswordModal(false);
          setSpinning(false)
          setAuthCodeCheck([true,""])
          setOtpCodeCheck([true,""])
          setCount(-1);
          passwordRef.current.resetFields();
        }}
      >
        <Form ref={passwordRef} >
          <Spin spinning={spinning}>
            <Form.Item
              name="emailCode"
              validateTrigger={["onChange","onBlur"]}
              onChange={()=>{setAuthCodeCheck([true,""])}}
              rules={[
                {
                  required: true,
                  message: "이메일 인증 코드를 입력하세요.",
                },
                {
                  validator: authCodeValidator,
                  validateTrigger:"onBlur"
                },
              ]}
            >
              <Input
                placeholder="이메일 인증 코드"
                suffix={
                  count > 0 ? (
                    <div style={{ color: "red" }}>{count}</div>
                  ) : (
                    <span style={{ cursor: "pointer" }} onClick={sendEmail}>
                      코드 전송
                    </span>
                  )
              }
              ></Input>
            </Form.Item>
          </Spin>
          <Form.Item
            name="otpCode"
            validateTrigger={["onChange","onBlur"]}
            onChange={()=>{setOtpCodeCheck([true,""])}}
            style={{ marginBottom: 0 }}
            rules={[
              {
                required: true,
                message: "GOOGLE OTP 코드를 입력하세요.",
              },
              {
                validator: otpCodeValidator,
                validateTrigger:"onBlur"
              },
            ]}
          >
            <Input placeholder="구글인증기 인증 코드"></Input>
          </Form.Item>
          <div>구글인증기에서 제시한 6자리의 숫자를 입력하세요</div>
          <Form.Item
            name="newPassword"
            style={{ marginTop: "20px" }}
            rules={[
              {
                required: true,
                message: "새로운 비밀번호를 입력하세요.",
              },
            ]}
          >
            <Input.Password placeholder="새로운 비밀번호"></Input.Password>
          </Form.Item>
          <Form.Item
            name="newPasswordCheck"
            rules={[
              {
                required: true,
                message: "새로운 비밀번호를 다시 한번 입력하세요",
              },
              {
                validator: passwordCheckValidator,
                validateTrigger:"onBlur"
              },
            ]}
          >
            <Input.Password placeholder="비밀번호 재입력"></Input.Password>
          </Form.Item>
        </Form>
      </Modal>

      <Spin spinning={spinState}>
        <Descriptions
          style={{ textAlign: "left", width: "100%", flexGrow: 1 }}
          title="개인 정보"
          column={3}
          bordered="true"
        >
          <Descriptions.Item label="이름">
            {/* {console.log(userInfo)} */}
            {!userInfo || userInfo.thumbnail === null ? (
              <Avatar icon={<UserOutlined />} />
            ) : (
              <Avatar src={`https://englemining-admin.s3.ap-northeast-2.amazonaws.com/${userInfo.thumbnail}`} onClick={viewPicture}/>
            )}
            <span style={{ paddingLeft: "5px" }}>
              {userInfo && userInfo.name}
            </span>
            <span style={{ paddingLeft: "10px" }}>
              {/* <button>사진 변경</button> */}
              <PictureUpload />
            </span>
          </Descriptions.Item>
          <Descriptions.Item label="소속">
            {userInfo && userInfo.department}
          </Descriptions.Item>
          <Descriptions.Item label="직책/직급">
            {userInfo && userInfo.responsibility + "/" + userInfo.position}
          </Descriptions.Item>
          <Descriptions.Item label="계정">
            {userInfo && userInfo.email}
          </Descriptions.Item>
          <Descriptions.Item label="비밀번호">
            <span style={{ paddingLeft: "5px" }}>
              {userInfo && userInfo.password ? "*******" : "없음"}
            </span>
            <span style={{ paddingLeft: "10px" }}>
              <Button onClick={changePassword}>변경</Button>
            </span>
          </Descriptions.Item>

          <Descriptions.Item label="MFA사용">
            <Switch
              checked={
                userInfo && userInfo.google_otp_use_yn === "Y" ? true : false
              }
              onChange={otpCheckHandler}
              defaultChecked={
                userInfo && userInfo.google_otp_use_yn === "Y" ? true : false
              }
            />
          </Descriptions.Item>

          <Descriptions.Item label="휴대폰 번호" span={3}>
            {userInfo && userInfo.phone}
          </Descriptions.Item>
          <Descriptions.Item label="관리영역" span={3}>
            {userInfo &&
              userInfo.menu_group.map((ele, idx) => (
                <div key={idx}>* {ele}</div>
              ))}
          </Descriptions.Item>
          <Descriptions.Item label="최근 접속 메뉴" span={3}>
            {userInfo &&
              `${userInfo.menu_name}(${newDateTime(userInfo.access_datetime)})`}
          </Descriptions.Item>
          <Descriptions.Item label="계정 상태" span={3}>
            {userInfo && userInfo.status === "1" ? "정상" : "해지"}
          </Descriptions.Item>
          <Descriptions.Item label="메모" style={{whiteSpace:"pre-line"}} span={3}>
            {userInfo && userInfo.description}
          </Descriptions.Item>
        </Descriptions>
      </Spin>
    </div>
  );
};

export default UserInfo;
